query emproContactTypes {
  emproContactTypes {
    id
    name
    contactMedium
  }
}
